import React, { useEffect, useState } from "react";
import AuctionSchedule from "../../commanPage/AuctionInfo/AuctionSchedule";
import { TimePicker } from "react-ios-time-picker";
import {
  addTimeToBase,
  convertTo12HourFormat,
  notifyError,
  timeToMinutes,
} from "../../../helper/helpers";
import LotTimeExtentionTable from "../table/LotTimeExtentionTable";
import { useDispatch, useSelector } from "react-redux";
import { updateAuctionTimeInLiveRoom } from "../../../redux/action/liveRoom";
import { ClipLoader } from "react-spinners";

function AuctionTimeExtention({
  singleAuctionData,
  singleAuctionLoading,
  offers,
  setIsExtendedTime
}) {
  const { auctionTimeLoading } = useSelector((state) => state.liveAuction);
  const dispatch = useDispatch();
  const [selectedOffers, setSelectedOffers] = useState([
    {
      offerId: "",
      extendMinutes: "",
      checkedOffer: false,
    },
  ]);
  const [updateTime, setUpdateTime] = useState("00:00");

  const handleAuctionTimeExtentionSubmit = async (
    selectedOffers,
    updateTime
  ) => {
    const auctionEndMinutes = timeToMinutes(updateTime);
    if (!updateTime || updateTime === "00:00") return notifyError("Please select a valid time to extend the auction base on highest update lot end time.");
    const invalidOffers = await selectedOffers.filter((offer) => {
      const offerEndMinutes = timeToMinutes(offer?.extendMinutes);
      return offerEndMinutes > auctionEndMinutes;
    });

    const validMsgForNotification = await invalidOffers?.map((offer) => {
      const matchedOffer = offers?.find(
        (item) => item?.fullOfferDetails?._id === offer?.offerId
      );
      return matchedOffer?.fullOfferDetails?.scrapDetails?.type;
    });
    if (validMsgForNotification?.length > 0)
      return notifyError(
        `Please select valid time for '${validMsgForNotification?.join(", ")}' must be less than or equal to the updated auction time.`
      );

    const updateTimeInMinutes = await selectedOffers
      ?.filter(
        (offer) =>
          offer?.extendMinutes !== "00:00" && offer?.extendMinutes !== ""
      )
      .map(({ checkedOffer, ...rest }) => ({
        ...rest,
        extendMinutes: timeToMinutes(rest?.extendMinutes),
      }));

    if (updateTimeInMinutes?.length === 0) return notifyError("Please select at least one offer to extend time.");

    dispatch(
      updateAuctionTimeInLiveRoom(singleAuctionData?._id, {
        extendMinutes: auctionEndMinutes,
        offersExtendMinutes: updateTimeInMinutes,
      }, setIsExtendedTime)
    );
  };

  useEffect(() => {
    if (offers?.length > 0) {
      const initialSelectedOffers = offers?.map((offer) => ({
        offerId: offer?.fullOfferDetails?._id,
        extendMinutes: `00:00`,
        checkedOffer: false,
      }));
      setSelectedOffers(initialSelectedOffers);
    }
  }, [offers]);

  return (
    <div>
      <h4 className="flex justify-center">Extend Auction Time</h4>
      <AuctionSchedule singleAuctionData={singleAuctionData} liveRoom={false} />
      <div className="flex gap-1 mt-1 column">
        <span className={`valign-wrapper pin-top gap-1`}>
          <h5 style={{ width: "400px" }}>Auction time Extended by :</h5>
          <span className="flex column full-width " >
            <p>HH:MM</p>
            <span
              className="input-tag-style margin-0px timerLocation"
              style={{ height: "46px" }}
            >
              <TimePicker
                role="input"
                type="time"
                required
                value={updateTime}
                cellHeight={70}
                onChange={(time) => setUpdateTime(time)}
              />
            </span>
          </span>
        </span>
      </div>
      <div className="flex gap-1 mt-2 column">
        <span className="valign-wrapper space-between">
          <h5> Extended lot time</h5>{" "}
          <h6 className="red-text">
            Auction Updated End Time :{" "}
            {addTimeToBase(
              convertTo12HourFormat(
                singleAuctionData?.auctionSchedule?.endingTime
              ),
              updateTime
            )}{" "}
          </h6>
        </span>

        <LotTimeExtentionTable
          offers={offers}
          singleAuctionLoading={singleAuctionLoading}
          selectedOffers={selectedOffers}
          setSelectedOffers={setSelectedOffers}
        />
      </div>
      <div className="valign-wrapper justify-center gap-2 mt-1">
        <button
          disabled={auctionTimeLoading || updateTime === "00:00"}
          className={`button-style pointer font-20px ${updateTime === "00:00" ? "grey lighten-2 grey-text" : "cercle-purple white-text"}`}
          style={{
            padding: "0.5rem 1rem",
          }}
          onClick={() =>
            handleAuctionTimeExtentionSubmit(selectedOffers, updateTime)
          }
        >
          <p className="margin-0px">
            {auctionTimeLoading ? (
              <ClipLoader color="green" size={20} />
            ) : (
              "Submit"
            )}
          </p>
        </button>
      </div>
    </div>
  );
}

export default AuctionTimeExtention;
